import {
  Button,
  Flex,
  Image,
  Input,
  Link,
  Text,
  useColorModeValue,
  useToast,
  Box,
  Heading,
  Divider,
  Icon,
  Tooltip,
  Spinner,
  Alert,
  AlertIcon,
  Badge,
  Radio,
  RadioGroup,
  Stack,
  Select
} from '@chakra-ui/react';
import Card from 'components/card/Card';
import SignatureCanvas from 'react-signature-canvas';
import React, { useRef, useState, useEffect } from 'react';
import resguardosApi from 'api/resguardos';
import { FaInfoCircle, FaSearch, FaSave, FaQrcode, FaUser, FaUserTie, FaCheckCircle, FaBuilding, FaPenNib, FaEdit, FaCheck, FaTimes } from 'react-icons/fa';

export default function YourOrderSteps(props: { [x: string]: any }) {
  const { ...rest } = props;
  const textColor = useColorModeValue('secondaryGray.900', 'white');
  const brandColor = useColorModeValue('brand.500', 'white');
  const borderColor = useColorModeValue('gray.200', 'gray.600');
  const [showQR, setShowQR] = useState(false);
  const sigCanvas = useRef<SignatureCanvas>(null);
  const toast = useToast();
  const [isSigned, setIsSigned] = useState(false);
  const [signatureURL, setSignatureURL] = useState<string | null>(null);
  
  // --- NUEVOS ESTADOS PARA EL TIPO DE COLABORADOR ---
  const [tipoColaborador, setTipoColaborador] = useState<'local' | 'foraneo' | 'externo'>('local');
  const [hotelForaneo, setHotelForaneo] = useState('GVRN');
  
  const [colaborador, setColaborador] = useState<{
    NombreCompleto?: string,
    clv_trab?: number,
    NombrePuesto?: string,
    Estatus?: string,
    NombreDepartamento?: string
  } | null>(null);

  const [claveTrabajador, setClaveTrabajador] = useState<string>('');
  const [departamento, setDepartamento] = useState<string>('');
  const [isEditingDepartamento, setIsEditingDepartamento] = useState(false);
  const [tempDepartamento, setTempDepartamento] = useState<string>('');
  const [busquedaDepartamento, setBusquedaDepartamento] = useState<string>('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [hasResguardo, setHasResguardo] = useState<boolean>(false);
  const [isCheckingResguardo, setIsCheckingResguardo] = useState<boolean>(false);
  const canvasBgColor = useColorModeValue('#f8f9fa', '#2d3748');
  const inputBgColor = useColorModeValue('gray.50', 'gray.700');

  // Lista de departamentos para el picklist
  const departamentosList = [
    "Tecnologias", "Nominas", "Contraloria", "Compras", "Ventas", "Auditoria", 
    "Social Media", "Costos", "AyB (Alimentos y Bebidas)", "Arquitectura", 
    "Seguridad", "Asistente de Obras", "Spa", "Ama de llaves", "USA", 
    "Actividades", "Show Room", "Hotel Manager", "Banquetes", "Experiencias", 
    "Concierge", "Steward", "Capacitación", "Calidad y Capacitación", 
    "Division Suite", "Cocina", "Recursos Humanos", "Mantenimiento", 
    "Jardines", "Areas Publicas", "Montajes", "Bellboys", "Recepcion", 
    "Call Center", "Direccion General", "Tiempo Compartido", "Almacén general", 
    "Reputation Manager", "Cluster"
  ];

  // Lista de Hoteles para colaborador foráneo
  const hotelesList = [
    { id: 'GVRN', nombre: 'Grand Velas Riviera Nayarit' },
    { id: 'GVRM', nombre: 'Grand Velas Riviera Maya' },
    { id: 'GVLC', nombre: 'Grand Velas Los Cabos' },
    { id: 'CV', nombre: 'Casa Velas' },
    { id: 'VV', nombre: 'Velas Vallarta' },
    { id: 'GVRN', nombre: 'Corporativo' }
  ];

  // Limpiar formulario al cambiar de tipo
  useEffect(() => {
    setColaborador(null);
    setClaveTrabajador('');
    setDepartamento('');
    setError(null);
    clearSignature();
  }, [tipoColaborador]);

  const getFechaActual = () => {
    const fecha = new Date();
    const opciones: Intl.DateTimeFormatOptions = {
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit',
      timeZone: 'America/Mexico_City'
    };
    return fecha.toLocaleDateString('es-MX', opciones);
  }

  const checkResguardo = async (numColab: number) => {
    setIsCheckingResguardo(true);
    try {
      const response = await fetch(`https://inventariosbackend.velasresorts.com/inventarios/resguardos/getResguardo?usuarioNumColab=${numColab}`);
      const data = await response.json();
      setHasResguardo(data[0] && data[0].length > 0);
    } catch (error) {
      console.error('Error al verificar resguardo:', error);
      setHasResguardo(false);
    } finally {
      setIsCheckingResguardo(false);
    }
  };

  const handleSave = async () => {
    if (sigCanvas.current?.isEmpty()) {
      toast({
        title: 'Firma requerida', description: 'Por favor firme antes de guardar.',
        status: 'warning', duration: 3000, isClosable: true, position: 'top-right'
      });
      return;
    }

    setIsLoading(true);
    setError(null);

    try {
      const dataURL = sigCanvas.current?.getCanvas().toDataURL('image/png');
      setSignatureURL(dataURL);
      setIsSigned(true);

      sessionStorage.setItem('firma', dataURL || '');
      sessionStorage.setItem('sign', '1');

      const userData = JSON.parse(sessionStorage.getItem('user') || '{}');
      userData.Firma = dataURL;
      sessionStorage.setItem('user', JSON.stringify(userData));

      // Solo guardamos en BD si el colaborador tiene clave (Local o Foráneo)
      // Si es Externo, solo guardamos en sesión para el proceso actual
      if (colaborador?.clv_trab) {
        const response = await fetch('https://inventariosbackend.velasresorts.com/inventarios/user/guardar-firma', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            usuarioNumColab: colaborador.clv_trab,
            FirmaDigital: dataURL,
            user: userData.Id
          })
        });

        if (!response.ok) throw new Error('Error al guardar la firma en el servidor');
        const result = await response.json();
        console.log('Firma guardada en servidor:', result);
      }

      toast({
        title: 'Enviado con éxito',
        description: 'La firma fue guardada correctamente.',
        status: 'success', duration: 4000, isClosable: true, position: 'top-right'
      });

      setModoFirma(false);
      setShowQR(true);
    } catch (error) {
      console.error('Error al guardar la firma:', error);
      setError((error as Error).message);
      toast({
        title: 'Error al enviar',
        description: 'Ocurrió un error al guardar la firma.',
        status: 'error', duration: 4000, isClosable: true, position: 'top-right'
      });
    } finally {
      setIsLoading(false);
    }
  };

  const fetchColaborador = async (clave: string) => {
    if (!clave) return; 
    
    clearSignature();
    setIsLoading(true);
    setError(null);
    setHasResguardo(false);
    setIsEditingDepartamento(false);

    try {
      // Lógica de URL dependiendo si es local o foráneo
      let hotelQuery = '';
      if (tipoColaborador === 'foraneo') {
        hotelQuery = hotelForaneo;
      } else {
        hotelQuery = sessionStorage.getItem('hotelSeleccionado')?.toLocaleUpperCase() || 'gvrn';
      }

      const url = `https://inventariosbackend.velasresorts.com/inventarios/abrhil?clTrabajador=${clave}&hotel=${hotelQuery}`;
      
      const firmaApiData = await resguardosApi.listado();
      const response = await fetch(url);
      const data = await response.json();

      const colaboradorData = Array.isArray(data)
        ? data.find((item: any) => item.Estatus === 'Vigente')
        : data;

      if (!colaboradorData) {
        setError('No se encontró el colaborador');
        setColaborador(null);
        return;
      }

      setColaborador(colaboradorData);

      if (colaboradorData?.NombreDepartamento) {
        setDepartamento(colaboradorData.NombreDepartamento);
        sessionStorage.setItem('departamento', colaboradorData.NombreDepartamento);
      } else {
        setDepartamento('');
      }

      if (colaboradorData?.clv_trab) {
        await checkResguardo(colaboradorData.clv_trab);
      }

      sessionStorage.setItem('colaborador', JSON.stringify(colaboradorData));

    } catch (error) {
      console.error('Error al obtener el colaborador:', error);
      setError('Error al buscar el colaborador');
    } finally {
      setIsLoading(false);
    }
  };

  // Manejador especial para Externos (sin API)
  const handleExternoChange = (nombre: string) => {
    setClaveTrabajador(nombre); // Usamos el state de clave como nombre para visualización
    if (nombre.trim() === '') {
      setColaborador(null);
      setDepartamento('');
      return;
    }
    
    // Creamos un objeto colaborador "dummy" para externos
    const externoData = {
      NombreCompleto: nombre,
      clv_trab: 0, // 0 o null para indicar que no es empleado
      NombrePuesto: 'Externo / Visitante',
      Estatus: 'Externo',
      NombreDepartamento: 'Externo'
    };
    
    setColaborador(externoData);
    setDepartamento('Externo');
    sessionStorage.setItem('colaborador', JSON.stringify(externoData));
    sessionStorage.setItem('departamento', 'Externo');
  };

  const clearSignature = () => {
    if (sigCanvas.current) sigCanvas.current.clear();
    setIsSigned(false);
    setSignatureURL(null);
    setShowQR(false);
  };

  const startEditingDepartamento = () => {
    setTempDepartamento(departamento);
    setBusquedaDepartamento('');
    setIsEditingDepartamento(true);
  };

  const saveDepartamento = () => {
    setDepartamento(tempDepartamento);
    if (colaborador) {
      const updatedColaborador = { ...colaborador, NombreDepartamento: tempDepartamento };
      setColaborador(updatedColaborador);
      sessionStorage.setItem('colaborador', JSON.stringify(updatedColaborador));
    }
    sessionStorage.setItem('departamento', tempDepartamento);
    setIsEditingDepartamento(false);
    toast({
      title: 'Departamento actualizado', status: 'success', duration: 2000, isClosable: true, position: 'top-right'
    });
  };

  const cancelEditingDepartamento = () => {
    setIsEditingDepartamento(false);
    setTempDepartamento(departamento);
  };

  const busquedaDepartamentoNormalizada = busquedaDepartamento.trim().toLowerCase();
  const departamentosFiltrados = busquedaDepartamentoNormalizada
    ? departamentosList.filter(depto => depto.toLowerCase().includes(busquedaDepartamentoNormalizada))
    : departamentosList;
  const departamentoNoExiste = busquedaDepartamento.trim() !== '' &&
    !departamentosList.some(depto => depto.toLowerCase() === busquedaDepartamentoNormalizada);

  const userData = JSON.parse(sessionStorage.getItem('user') || '{}');
  sessionStorage.setItem("firma", userData.Firma);

  const firmaGuardada = userData.Firma && userData.Firma.toLowerCase() !== 'Sin firma registrada'
    ? userData.Firma : null;
  const [modoFirma, setModoFirma] = useState(false);

  return (
    <Card
      w='100%' p='15px' flexDirection={{ base: 'column', md: 'row' }}
      gap={6} flexWrap="wrap" boxShadow="lg" borderRadius="xl" {...rest}
    >
      {/* Sección de Información del Colaborador */}
      <Box flex="1" minW="250px" p={4} borderRight={{ md: '1px solid' }} borderColor={{ md: borderColor }}>
        <Heading size="md" mb={4} color={brandColor} display="flex" alignItems="center">
          <Icon as={FaUser} mr={2} /> Información del Colaborador
        </Heading>

        {/* --- SELECTOR DE TIPO DE COLABORADOR --- */}
        <Box mb={5} bg={useColorModeValue('gray.50', 'gray.700')} p={3} borderRadius="md">
            <Text fontSize="sm" fontWeight="bold" mb={2} color="secondaryGray.600">Tipo de colaborador:</Text>
            <RadioGroup onChange={(val: any) => setTipoColaborador(val)} value={tipoColaborador}>
            <Stack direction='row' spacing={4} wrap="wrap">
                <Radio value='local' colorScheme='brand'>Local</Radio>
                <Radio value='foraneo' colorScheme='orange'>Foráneo</Radio>
                <Radio value='externo' colorScheme='purple'>Externo</Radio>
            </Stack>
            </RadioGroup>
        </Box>

        {isLoading ? (
          <Flex justify="center" my={8}><Spinner size="lg" /></Flex>
        ) : error ? (
          <Alert status="error" mb={4} borderRadius="md"><AlertIcon />{error}</Alert>
        ) : (
          <>
            <Box mb={6}>
              {/* LÓGICA DE INTERFAZ SEGÚN TIPO */}
              
              {/* CASO 1: LOCAL */}
              {tipoColaborador === 'local' && (
                <>
                  <Text color='secondaryGray.600' fontSize='md' fontWeight='500' mb={2}>
                    Buscar por clave (Local):
                  </Text>
                  <Flex gap={2} align="center" mb={4}>
                    <Input
                      value={claveTrabajador}
                      onChange={(e) => {
                        setClaveTrabajador(e.target.value);
                        if (e.target.value === '') clearSignature();
                      }}
                      onKeyDown={(e) => { if (e.key === 'Enter') fetchColaborador(claveTrabajador); }}
                      placeholder="Clave de trabajador"
                      size="md"
                      focusBorderColor={brandColor}
                    />
                    <Button
                      onClick={() => fetchColaborador(claveTrabajador)}
                      leftIcon={<FaSearch />}
                      colorScheme="blue"
                      isLoading={isLoading || isCheckingResguardo}
                    >
                      Buscar
                    </Button>
                  </Flex>
                </>
              )}

              {/* CASO 2: FORÁNEO */}
              {tipoColaborador === 'foraneo' && (
                <>
                  <Text color='secondaryGray.600' fontSize='md' fontWeight='500' mb={2}>
                    Seleccionar Hotel:
                  </Text>
                  <Select 
                    mb={3} 
                    value={hotelForaneo} 
                    onChange={(e) => setHotelForaneo(e.target.value)}
                    bg={inputBgColor}
                  >
                    {hotelesList.map(hotel => (
                        <option key={hotel.id} value={hotel.id}>{hotel.nombre}</option>
                    ))}
                  </Select>

                  <Text color='secondaryGray.600' fontSize='md' fontWeight='500' mb={2}>
                    Buscar por clave (Foráneo):
                  </Text>
                  <Flex gap={2} align="center" mb={4}>
                    <Input
                      value={claveTrabajador}
                      onChange={(e) => {
                        setClaveTrabajador(e.target.value);
                        if (e.target.value === '') clearSignature();
                      }}
                      onKeyDown={(e) => { if (e.key === 'Enter') fetchColaborador(claveTrabajador); }}
                      placeholder={`Clave de ${hotelForaneo}`}
                      size="md"
                      focusBorderColor="orange.500"
                    />
                    <Button
                      onClick={() => fetchColaborador(claveTrabajador)}
                      leftIcon={<FaSearch />}
                      colorScheme="orange"
                      isLoading={isLoading || isCheckingResguardo}
                    >
                      Buscar
                    </Button>
                  </Flex>
                </>
              )}

              {/* CASO 3: EXTERNO */}
              {tipoColaborador === 'externo' && (
                <>
                  <Text color='secondaryGray.600' fontSize='md' fontWeight='500' mb={2}>
                    Nombre completo del externo:
                  </Text>
                  <Input
                    value={colaborador?.NombreCompleto || ''}
                    onChange={(e) => handleExternoChange(e.target.value)}
                    placeholder="Escribe el nombre completo"
                    size="md"
                    focusBorderColor="purple.500"
                    mb={4}
                  />
                  <Text fontSize="xs" color="gray.500">
                    * Los usuarios externos no se validan en la base de datos.
                  </Text>
                </>
              )}

              {/* Muestra de datos encontrados */}
              {(colaborador) && (
                  <Box mt={4} p={3} bg="gray.50" borderRadius="md" border="1px dashed" borderColor="gray.300">
                     <Flex align="center">
                        <Text color='secondaryGray.600' fontSize='md' fontWeight='500' mr={2}>
                        Nombre:
                        </Text>
                        <Text color={textColor} fontSize='md' fontWeight='600'>
                        {colaborador?.NombreCompleto ?? 'No disponible'}
                        </Text>
                    </Flex>
                  </Box>
              )}

              <Divider my={4} borderColor={borderColor} />

              {/* Picklist de Departamentos (Mantenido para todos, incluso externo si desea editar) */}
              <Box>
                <Text color='secondaryGray.600' fontSize='md' fontWeight='500' mb={2}>
                  Departamento:
                </Text>

                {isEditingDepartamento ? (
                  <Box>
                    <Input
                      value={busquedaDepartamento}
                      onChange={(e) => setBusquedaDepartamento(e.target.value)}
                      placeholder="Buscar departamento..."
                      size="sm" mb={2} bg={inputBgColor}
                    />
                    <Flex gap={2} align="center" mb={2}>
                      <Box flex="1" border="1px solid" borderColor={borderColor} borderRadius="md" maxH="150px" overflowY="auto" bg={inputBgColor}>
                        {departamentosFiltrados.map((depto, index) => (
                          <Box
                            key={index} p={2} cursor="pointer"
                            bg={tempDepartamento === depto ? brandColor : 'transparent'}
                            color={tempDepartamento === depto ? 'white' : textColor}
                            _hover={{ bg: tempDepartamento === depto ? brandColor : 'gray.100' }}
                            onClick={() => setTempDepartamento(depto)}
                          >
                            <Text fontSize="sm">{depto}</Text>
                          </Box>
                        ))}
                        {departamentoNoExiste && (
                          <Box
                            p={2} cursor="pointer"
                            bg={tempDepartamento === busquedaDepartamento.trim() ? brandColor : 'transparent'}
                            color={tempDepartamento === busquedaDepartamento.trim() ? 'white' : 'blue.500'}
                            _hover={{ bg: tempDepartamento === busquedaDepartamento.trim() ? brandColor : 'gray.100' }}
                            onClick={() => setTempDepartamento(busquedaDepartamento.trim())}
                            borderTop="1px solid" borderColor={borderColor}
                          >
                            <Text fontSize="sm" fontWeight="500">
                              + Agregar "{busquedaDepartamento.trim()}" como nuevo departamento
                            </Text>
                          </Box>
                        )}
                        {departamentosFiltrados.length === 0 && !departamentoNoExiste && (
                          <Text fontSize="sm" color="gray.500" p={2} textAlign="center">
                            No se encontraron departamentos.
                          </Text>
                        )}
                      </Box>
                    </Flex>
                    <Flex gap={2} mt={2}>
                      <Button size="sm" onClick={saveDepartamento} colorScheme="green" leftIcon={<FaCheck />} flex="1" isDisabled={!tempDepartamento}>Confirmar</Button>
                      <Button size="sm" onClick={cancelEditingDepartamento} colorScheme="red" variant="outline" leftIcon={<FaTimes />} flex="1">Cancelar</Button>
                    </Flex>
                  </Box>
                ) : (
                  <Box>
                    <Flex gap={2} align="center" mb={2}>
                      <Input
                        value={departamento} isReadOnly placeholder="No disponible"
                        size="md" flex="1" bg={inputBgColor}
                      />
                      <Button
                        size="sm" onClick={startEditingDepartamento} colorScheme="blue" leftIcon={<FaEdit />}
                        isDisabled={!colaborador}
                      >
                        Editar
                      </Button>
                    </Flex>
                  </Box>
                )}
              </Box>

              {hasResguardo && (
                <Badge colorScheme="red" mt={2} p={2} borderRadius="md" fontSize="sm">
                  Ya tiene resguardo
                </Badge>
              )}
            </Box>
          </>
        )}
      </Box>

      {/* Sección Información del Usuario (Resumen derecho) */}
      <Box flex="1" minW="250px" p={4} borderRight={{ md: '1px solid' }} borderColor={{ md: borderColor }}>
        <Heading size="md" mb={4} color={brandColor} display="flex" alignItems="center">
          <Icon as={FaUser} mr={2} /> Información del Usuario
        </Heading>

        <Flex align="center" mb={3}>
          <Icon as={FaUserTie} color="secondaryGray.600" mr={2} />
          <Box>
            <Text color='secondaryGray.600' fontSize='sm' fontWeight='500'>Puesto:</Text>
            <Link color={brandColor} href="#" fontSize='sm' fontWeight='600'>
              {colaborador?.NombrePuesto ?? 'No disponible'}
            </Link>
          </Box>
        </Flex>

        <Flex align="center" mb={3}>
          <Icon as={FaCheckCircle} color="secondaryGray.600" mr={2} />
          <Box>
            <Text color='secondaryGray.600' fontSize='sm' fontWeight='500'>Estatus:</Text>
            <Badge colorScheme={tipoColaborador === 'externo' ? 'purple' : 'green'}>
                {colaborador?.Estatus ?? 'No disponible'}
            </Badge>
          </Box>
        </Flex>

        <Flex align="center" mb={3}>
          <Icon as={FaBuilding} color="secondaryGray.600" mr={2} />
          <Box>
            <Text color='secondaryGray.600' fontSize='sm' fontWeight='500'>Departamento:</Text>
            <Text color={textColor} fontSize='sm' fontWeight='600'>
              {departamento || 'No disponible'}
            </Text>
          </Box>
        </Flex>

        <Divider my={4} borderColor={borderColor} />

        <Flex align="center">
          <Icon as={FaPenNib} color="secondaryGray.600" mr={2} />
          <Box>
            <Text color='secondaryGray.600' fontSize='sm' fontWeight='500'>Fecha de firma:</Text>
            <Text color={textColor} fontSize='sm' fontWeight='600'>{getFechaActual()}</Text>
          </Box>
        </Flex>
      </Box>

      {/* Sección de Firma Digital */}
      <Box flex="1" minW="300px" p={4} display="flex" flexDirection="column" alignItems="center">
        {firmaGuardada && !modoFirma ? (
          <>
            <Heading size="md" mb={4} color={brandColor} display="flex" alignItems="center">
              <Icon as={FaQrcode} mr={2} /> Comprobante
            </Heading>
            <Box mb={6} textAlign="center">
              <Text mb={2} color={textColor} fontSize='md' fontWeight="600">Firma generada:</Text>
              <Box>
                <Text mb={1} fontSize="sm" color="gray.500">Firma</Text>
                <Image src={firmaGuardada} alt="Firma" border={`1px solid ${borderColor}`} borderRadius="md" boxShadow="sm" maxW="200px" />
              </Box>
            </Box>
            <Button colorScheme="blue" onClick={() => setModoFirma(true)}>Cambiar firma</Button>
          </>
        ) : (
          <>
            <Heading size="md" mb={4} color={brandColor}>Firma Digital</Heading>
            <Text mb={4} color={textColor} fontSize='sm' textAlign="center">
              Por favor, firme en el área designada para completar el proceso.
            </Text>
            <Box border={`1px solid ${borderColor}`} borderRadius="md" p={2} mb={4} w="100%" maxW="400px">
              <SignatureCanvas
                ref={sigCanvas} penColor='black'
                canvasProps={{
                  width: 350, height: 150, className: 'sigCanvas',
                  style: { backgroundColor: canvasBgColor, borderRadius: '6px' }
                }}
              />
            </Box>
            <Flex gap={3}>
              <Button colorScheme="red" variant="outline" onClick={clearSignature} disabled={!sigCanvas.current || sigCanvas.current?.isEmpty()}>Limpiar</Button>
              {/* Deshabilitar guardar si no hay colaborador seleccionado/escrito */}
              <Button colorScheme="blue" onClick={handleSave} isLoading={isLoading} loadingText="Guardando..." leftIcon={<FaSave />} isDisabled={!colaborador}>
                Guardar Firma
              </Button>
            </Flex>
            <Tooltip label="Su firma será asociada a los activos seleccionados" placement="top" hasArrow>
              <Box mt={4} textAlign="center" color="secondaryGray.600">
                <Icon as={FaInfoCircle} mr={1} />
                <Text as="span" fontSize="sm">¿Para qué es esta firma?</Text>
              </Box>
            </Tooltip>
          </>
        )}
      </Box>
    </Card>
  );
}